// Module
var code = "<div> <assignments-manager ng-if=\"!assignments.tempHide\" manager=\"manager && manager._id\" select-content=\"assignments.goToContent(content)\" select-user=\"assignments.goToUser(user)\" manager-configuration=\"managerConfiguration || null\"></assignments-manager> </div> ";
// Exports
module.exports = code;